// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
import CSSStyles from "enums/cssStyles";

// MARK: Styled Components
interface AlertBarProps {
  opacity: number;
  navigationBarHeight: number;
  color: string;
  backgroundcolor: string;
}

const Container = styled.div<AlertBarProps>`
  pointer-events: ${({ opacity }) => (opacity === 1 ? "" : "none")};
  opacity: ${({ opacity }) => opacity};
  position: fixed;
  z-index: 10000;
  top: ${({ navigationBarHeight }) => navigationBarHeight}px;
  left: 0;
  right: 0;
  min-height: 40px;
  width: 100vw;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px 20px;
  display: flex;
  background-color: ${({ backgroundcolor }) => backgroundcolor};
  color: ${({ color }) => color};
  transition: 0.6s cubic-bezier(0.19, 1, 0.22, 1);
  font-display: swap;
`;

// MARK: React Component
// Props
interface Props {
  opacity: number;
  children: any;
}
// Styleguide & Datapoints
const getDataPoints = (styleguide: ReduxStyleguide) => {
  const { colors } = styleguide;
  const { primary, background } = colors;
  return {
    style: CSSStyles.navigation,
    color: background,
    backgroundColor: primary,
  };
};
// Component

const AlertBar = ({ opacity, children }: Props) => {
  // MARK: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: Variables
  const { navigationBarHeight } = styleguide;
  const { style, color, backgroundColor } = getDataPoints(styleguide);
  // MARK: Functionality

  // MARK: Render
  return (
    <Container
      opacity={opacity}
      className={style}
      navigationBarHeight={navigationBarHeight}
      color={color}
      backgroundcolor={backgroundColor}
    >
      {children}
    </Container>
  );
};

export default AlertBar;
